import { z } from "zod";
/**
 * Toda respuesta del API tiene una de estas dos formas. Nunca otra.
 * El frontend puede confiar en `ok` para decidir sin inspeccionar el cuerpo.
 */
export const errorBodySchema = z.object({
    code: z.string(),
    message: z.string(),
    /** Errores por campo, cuando la falla es de validación. */
    fields: z.record(z.string(), z.array(z.string())).optional(),
    /** Para rastrear la petición en los logs del servidor. */
    requestId: z.string().optional(),
});
export const failureSchema = z.object({
    ok: z.literal(false),
    error: errorBodySchema,
});
/** Envuelve el esquema de datos de un endpoint exitoso. */
export function successSchema(data) {
    return z.object({ ok: z.literal(true), data });
}
/** La respuesta completa de un endpoint: éxito o falla. */
export function responseSchema(data) {
    return z.discriminatedUnion("ok", [successSchema(data), failureSchema]);
}
/**
 * Códigos de error del dominio. El frontend ramifica sobre estos,
 * nunca sobre el texto del mensaje.
 */
export const ERROR_CODES = {
    VALIDATION_ERROR: "VALIDATION_ERROR",
    UNAUTHENTICATED: "UNAUTHENTICATED",
    FORBIDDEN: "FORBIDDEN",
    NOT_FOUND: "NOT_FOUND",
    CONFLICT: "CONFLICT",
    RATE_LIMITED: "RATE_LIMITED",
    INTERNAL: "INTERNAL",
    // Autenticación
    EMAIL_TAKEN: "EMAIL_TAKEN",
    INVALID_CREDENTIALS: "INVALID_CREDENTIALS",
    ACCOUNT_LOCKED: "ACCOUNT_LOCKED",
    EMAIL_NOT_VERIFIED: "EMAIL_NOT_VERIFIED",
    TOKEN_EXPIRED: "TOKEN_EXPIRED",
    TOKEN_INVALID: "TOKEN_INVALID",
    /**
     * Pagos: la pasarela existe, está configurada, y aun así no se pudo
     * abrir el cobro. Stripe rechazó la llamada, se cayó la red o tardó
     * más que el timeout.
     *
     * Tiene código propio y no `INTERNAL` porque el frontend necesita
     * separarlo de dos vecinos que se le parecen: "todavía no hay claves"
     * —que NO es un error y viaja como dato, ver `contracts/checkout.ts`—
     * y "no se pudo contactar al servidor", que es nuestro. Los tres se
     * arreglan de forma distinta y quien los ve merece saber cuál le tocó.
     */
    PAYMENT_PROVIDER_ERROR: "PAYMENT_PROVIDER_ERROR",
    /**
     * Envíos (Trasso). `SHIPPING_NOT_CONFIGURED` = falta la llave en el
     * servidor: no es un fallo de nadie, es una función apagada, y el
     * panel lo dice así. `SHIPPING_PROVIDER_ERROR` = la llave existe y
     * Trasso (o su paquetería) no pudo: el mensaje trae el porqué que
     * ellos dieron — saldo insuficiente, cotización vencida, paquetería
     * caída — porque quien opera el panel decide distinto en cada caso.
     */
    SHIPPING_NOT_CONFIGURED: "SHIPPING_NOT_CONFIGURED",
    SHIPPING_PROVIDER_ERROR: "SHIPPING_PROVIDER_ERROR",
};
//# sourceMappingURL=http.js.map